import React from "react"
import styled, { keyframes } from "styled-components"
import * as vars from "../style/vars"
import { below, above, clearFix } from "../style/functions"
import RegisterForm from "../components/enqForm"

import Link from "gatsby-link"

class StickyEnquire extends React.Component {
   constructor(props) {
      super(props)
      this.state = {
         hide: false,
         popupVisible: false,
      }
   }


   componentDidMount() {

   }

   componentDidUpdate(prevProps) {
      if (this.props.togglePopupState) {
         document.body.style.overflow = 'hidden';
      }else{
         document.body.style.overflow = 'unset';
      }
   }

   render() {


      // console.log(this.props);
      //console.log(this.props.property);
      return (
         <Popup>
         <StickyBadge theme={this.props.theme} onClick={e => {this.props.togglePopup();}}>
         <span>Enquire Now</span>
         </StickyBadge>


            <PopupWrapper className={this.props.togglePopupState?'fadeIn':'fadeOut'}>
               <EnquiryWrapper className={this.props.togglePopupState?'slideIn':'slideOut'}>
                  <div className="close-button" onClick={e => {this.props.togglePopup();}} />
                  <h2>Enquire Now</h2>
                  <h4>
                     Enquire about YarraBend and one of our team members will get back
                     to you.
                  </h4>
                  <RegisterForm  property={this.props.property} square={true} utm={this.props.utm} updateFormDetails={(first_name,last_name,phone,email,property) => this.props.updateFormDetails(first_name,last_name,phone,email,property)}/>
               </EnquiryWrapper>

               </PopupWrapper>




        </Popup>
      )
   }
}

const Popup = styled.div`
.efwrapper{
   form{
      max-width:37rem;
      > div{
         width: 100%;
         margin-bottom:1.2rem

      }
   }
}
`
const PopupWrapper = styled.div`
position:fixed;
top:0; right:0; bottom:0; left:0;
background-color:rgba(255,255,255,.6);
z-index:1005!important;

opacity:0;
visibility: hidden;


&.fadeOut{
   opacity:0;
   visibility: hidden;
   transition: opacity 0.3s,  visibility 0.3s;

}
&.fadeIn{
   opacity:1;
   visibility:visible;
   transition: opacity 0.3s,  visibility 0.3s;


}


`

const EnquiryWrapper = styled.div`

   position:fixed!important;
   top:0!important;
   right:0!important;
   color:#fff;
   text-align: center;
   padding: 5.6rem 3.5rem;
   max-width: 60rem;
   width: 60rem;
   background: #333132;
   position: relative;
   z-index: 1010;

   overflow: scroll;
   max-height: 100%;

   ${below.tablet`;
      margin-top:0;
      left:0;
      max-width:100%;
      width:100%;
   `}
   ${below.xs`;
   padding: 3rem;
   `}
   opacity:0;
   ${above.tablet`
   transform: translateX(100%);
   `}

   ${below.tablet`
      transform: translateY(-100%);
   `}

   &.slideOut{
      opacity:0;


      ${above.tablet`
      transform: translateX(100%);
      `}
      ${below.tablet`
      transform: translateY(-100%);
      `}

      visibility: hidden;
      transition: opacity 0.3s,  visibility 0.3s ,  transform 0.3s;

   }
   &.slideIn{
      opacity:1;


      ${above.tablet`
      transform: translateX(0);
      `}
      ${below.tablet`
      transform: translateY(0);
      `}

      visibility:visible;
      transition: opacity 0.3s,  visibility 0.3s,  transform 0.3s;
   }

   h2 {
      padding-bottom: 3.4rem;
      font-size: 4.8rem;
      letter-spacing: -.02em;
      ${below.mobile`;
			padding-bottom: 2.5rem;
      `};

      ${below.xs`
      font-size: 3.4rem;
      `};
   }

   h4 {
      margin: 0 auto;
      max-width: 45rem;
      font-size: 2.3rem;
      line-height: 1.16;
      letter-spacing: .02em;
      font-weight: normal;
      padding-bottom: 3.2rem;
      ${below.mobile`;
         font-size: 1.9rem;
         line-height: 1.3;
      `};

      ${below.xs`
      font-size: 14px;
      padding-bottom: 3rem;
      `};
   }

   form {
      margin: 0 auto;
      text-align: left;

      ${below.tablet`
         font-size:16px;
      `};

      button {
         color: ${vars.colors.inactiveColor};
         font-size: 1.5rem;
         margin-top: 4rem;
         color: #333132!important;
         background-color:#fff!important;
         ${below.tablet`
            display: block!important;
            min-width: 230px;

            span{
               font-size:16px!important;
            }
         `};
      }
      input,label{
         padding-left:0;
         color:#fff!important;

      }

      label{
         ${below.tablet`
         bottom: 0.3em;
         `}
      }
   }

   .close-button {
      position: absolute;
      display: block;
      top: 1.8rem;
    right: 2.2rem;
      height: 35px;
      width: 35px;
      cursor: pointer;

      ${below.xs`
      top: 1rem;
      right: 1rem;
      `};

      &:before {
         content: "";
         position: absolute;
         display: block;
         height: 1px;
         width: 35px;
         top: 17px;
         right: 0;
         background-color: rgb(255, 255, 255);
         transform: rotate(45deg);
      }

      &:after {
         content: "";
         position: absolute;
         display: block;
         height: 1px;
         width: 35px
         top: 17px;
         right: 0;
         background-color: rgb(255, 255, 255);
         transform: rotate(-45deg);
         cursor: pointer;
      }
   }

`

const StickyBadge = styled.button`
   background-color:#414141;
   display: inline-block;
   position: fixed;
   z-index: 80;
   top: 490px;
   top: 50%;
   right: -68px;
   min-width: 176px;
   box-shadow: 0 2px 10px 3px rgba(255,255,255,.3);
   border: 0;
   border-radius: 0
   padding: 13px 13px;
   font-size: 14px;
   line-height: 1;
   color: #fff;
   text-decoration: none;
   text-align: center;
   text-transform: uppercase;
   transform: rotate(-90deg);
   transition: 0s;
   backface-visibility: hidden;
   will-change: transform;
   letter-spacing:.03em
   cursor: pointer;

   ${props => props.theme == "light" &&`
      background-color:#cccccc;
      color: #414141;
      box-shadow: 0 2px 10px 3px rgba(0,0,0,.2);
   `}



   ${above.tablet`
      transition: background-color .3s ease

      &:hover{
         background-color:#656565;
         transition: background-color .3s ease

         ${props => props.theme == "light" &&`
            background-color:#fff;
         `}

      }
   `}

   ${below.tablet`
      transform: none;
      top:80px;
      left:0;
      right:0;
      width:100%;
      text-align:center;
      right:auto;
      box-shadow: none;
      text-transform: capitalize;
      background-color:#cccccc;
      color:#414141;
      font-size:16px;

      ${props => props.theme == "dark" &&`
         background-color:#414141;
         color: #fff;
      `}

      :after {
         content: ' →';
         margin-left: .5rem;
         -webkit-transition: margin-left .5s;
         transition: margin-left .5s;
         font-size: 13px;
         -webkit-text-decoration: none;
         text-decoration: none;
      }

      span{
         text-decoration:underline;
      }
   `}

   ${below.mobile`
      top:41.5px;
      font-size:14px;
      padding:10px;
   `}
`


export default StickyEnquire



// WEBPACK FOOTER //
// ./src/components/sticky-enquire.js